import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import { calculateFlowDurationFromSlots } from '@/components/flows/detail/slot-list/calculate';
import { resolveRefId } from '@/helpers/object.id.helper';

/** Prefer fixed planned length on the PLAN doc, then computed, then slot sum. */
export function resolveFlowDurationMinutes(
  flow: Pick<FlowDto, 'durationPlannedMinutes' | 'computedDurationMinutes' | 'slots'>,
): number {
  if (typeof flow.durationPlannedMinutes === 'number' && flow.durationPlannedMinutes > 0) {
    return flow.durationPlannedMinutes;
  }
  if (typeof flow.computedDurationMinutes === 'number' && flow.computedDurationMinutes > 0) {
    return flow.computedDurationMinutes;
  }
  return calculateFlowDurationFromSlots(flow.slots ?? []) ?? 0;
}

/**
 * Minimum `playout_hours` that covers the flow: ceil(minutes / 60).
 * e.g. 4:45 → 5 hours. Returns 0 when length is unknown/zero.
 */
export function minPlayoutHoursForFlow(
  flow: Pick<FlowDto, 'durationPlannedMinutes' | 'computedDurationMinutes' | 'slots'> | undefined | null,
): number {
  if (!flow) return 0;
  const minutes = resolveFlowDurationMinutes(flow);
  if (!(minutes > 0)) return 0;
  return Math.ceil(minutes / 60);
}

export function flowMatchesScopeId(flow: FlowDto, scopeId: string): boolean {
  const origin = resolveRefId(flow.origin as Parameters<typeof resolveRefId>[0]);
  return origin === scopeId || flow.id === scopeId;
}
